"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditFriendsSection = EditFriendsSection;
var _solidUi = require("solid-ui");
var _texts = require("../texts");
function EditFriendsSection(context, me, editableProfile, profile) {
  const section = context.dom.createElement('section');
  section.setAttribute('aria-labelledby', 'edit-profile-friends-heading');
  section.classList.add('profileSection', 'section-bg');
  const header = context.dom.createElement('header');
  header.classList.add('text-center', 'mb-md');
  const heading = context.dom.createElement('h2');
  heading.id = 'edit-profile-friends-heading';
  heading.classList.add('section-title');
  heading.textContent = _texts.friendsHeadingText;
  header.appendChild(heading);
  section.appendChild(header);
  const comment1 = context.dom.createElement('p');
  comment1.id = 'edit-profile-friends-description';
  comment1.classList.add('p-md');
  comment1.textContent = 'This is your public social network. Only put people here to whom you are happy to be publicly connected. (You can always keep private track of friends and family in your contacts.)';
  section.appendChild(comment1);
  let comment2 = null;
  if (editableProfile) {
    comment2 = context.dom.createElement('p');
    comment2.id = 'edit-profile-friends-help';
    comment2.classList.add('p-md');
    comment2.textContent = 'Drag people onto the target below to add people.';
    section.appendChild(comment2);
  }
  const attachmentList = _solidUi.widgets.attachmentList(context.dom, me, section, {
    doc: profile,
    modify: !!editableProfile,
    predicate: _solidUi.ns.foaf('knows'),
    noun: 'friend'
  });
  const descriptions = [comment1.id];
  if (comment2?.id) {
    descriptions.push(comment2.id);
  }
  attachmentList.setAttribute('aria-describedby', descriptions.join(' '));
  section.appendChild(attachmentList);
  return section;
}